import templateUrl from "servicestack/auto-query/auto-query-headlines.htm";

export default {
  bindings: {
    headlines: "<"
  },
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  }
};
